import React from "react";
import { Box, Paper, Typography, Stack, Collapse, Grid, Divider, Button } from "@mui/material";
import { CustomChip, config } from './CustomChips'

function formatDate(dateString) {
	const date = new Date(dateString);

	const day = date.getDate().toString().padStart(2, '0');
	const month = date.toLocaleString('en-IN', { month: 'short' });
	const year = date.getFullYear();

	return `${day} ${month}, ${year}`;
}

export default function TransactionItem(props) {
	return (
		<Box sx={{ marginBottom: '10px' }}>
			<Button variant="text" sx={{ color: 'revert', textTransform: 'none', width: '100%', padding: 0, borderRadius: '5px', border: 'none', marginBottom: '5px' }} onClick={props.setExpanded}>
				<Paper elevation={3} sx={{ width: '100%', padding: '10px 20px' }}>
					<Stack flexDirection="row" alignContent="center" justifyContent="space-between" sx={{ height: '100%', width: '100%' }}>
						<Stack flexDirection="column" alignContent="center" justifyContent="space-between">
							<Typography textAlign="center" fontSize="1.2rem">{props.transaction_id}</Typography>
							<Typography textAlign="center" fontSize="0.9rem">{formatDate(props.transaction_date)}</Typography>
						</Stack>
						<Stack flexDirection="column" alignContent="center" justifyContent="space-between">
							<CustomChip {...config[props.transaction_type]} label={props.label} />
							<Typography textAlign="center" fontSize="0.9rem">₹ {props.total_amount}</Typography>
						</Stack>
					</Stack>
				</Paper>
			</Button>
			<Collapse in={props.expanded}>
				<Paper elevation={3} sx={{ padding: '10px', borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
					{props.items.map(item =>
						<Paper elevation={0} key={item.item_id} sx={{ border: '1px solid', width: '100%', padding: '10px 20px', borderRadius: '5px', marginBottom: "5px" }} component="button" onClick={props.setExpanded}>
							<Grid container alignItems='center'>
								<Grid item xs={7} sm={9} md={10} lg={10.5}>
									<Typography width='fit-content' textAlign="left" fontSize="1rem">{item.item_name_text}</Typography>
									<Typography width='fit-content' textAlign="left" fontSize="0.9rem">{item.barcode_id}</Typography>
								</Grid>
								<Grid item xs={5} sm={3} md={2} lg={1.5}>
									<Stack flexDirection="column" alignContent="center" justifyContent="space-between">
										<Typography textAlign="center" fontSize="1rem">₹ {item[props.transaction_type === 'purchase' ? 'cp' : 'sp']}</Typography>
										<Typography textAlign="center" fontSize="1rem">x {item.item_qt}</Typography>
										<Divider variant="middle" />
										<Typography textAlign="center" fontSize="1rem">₹ {Number(item.item_qt) * Number(item[props.transaction_type === 'purchase' ? 'cp' : 'sp'])}</Typography>
									</Stack>
								</Grid>
							</Grid>
						</Paper>
					)}
				</Paper>
			</Collapse>
		</Box>
	)
}